import { Address } from 'viem'

export const SMART_SESSIONS_ADDRESS: Address =
  '0x00000000002B0eCfbD0496EE71e01257dA0E37DE'
export const SMART_SESSIONS_COMPATIBILITY_FALLBACK_ADDRESS: Address =
  '0xBad7E91C4F2803978cd6c7C3Fe80B5Fd7f7B0b50'
